import { ReactNode } from "react";

import Typography from "../typography";
import { cn } from "../../utls/utils";

export type DetailSectionTone = "warm" | "neutral";

const toneClasses: Record<DetailSectionTone, { container: string; header: string; title: string; description: string }> = {
  warm: {
    container: "border-beige-200 bg-white",
    header: "border-beige-200 bg-cream-100",
    title: "text-terracotta-700",
    description: "text-brown-600",
  },
  neutral: {
    container: "border-beige-200 bg-white",
    header: "border-beige-100 bg-white",
    title: "text-brown-700",
    description: "text-brown-500",
  },
};

export interface DetailSectionProps {
  title: string;
  description?: ReactNode;
  children: ReactNode;
  actions?: ReactNode;
  tone?: DetailSectionTone;
  className?: string;
  contentClassName?: string;
}

export function DetailSection({
  title,
  description,
  children,
  actions,
  tone = "warm",
  className,
  contentClassName,
}: DetailSectionProps) {
  const toneStyles = toneClasses[tone];

  return (
    <section
      className={cn(
        "rounded-2xl border shadow-sm",
        toneStyles.container,
        className
      )}
    >
      <header
        className={cn(
          "flex flex-col gap-4 border-b p-6 sm:flex-row sm:items-center sm:justify-between",
          toneStyles.header
        )}
      >
        <div className="space-y-2">
          <Typography variant="h4" className={cn(toneStyles.title)}>
            {title}
          </Typography>
          {description ? (
            <Typography variant="body2" className={cn(toneStyles.description)}>
              {description}
            </Typography>
          ) : null}
        </div>
        {actions ? <div className="flex flex-wrap gap-2">{actions}</div> : null}
      </header>
      <div className={cn("space-y-4 p-6", contentClassName)}>{children}</div>
    </section>
  );
}

export default DetailSection;
